<template>
	<v-card elevation="0" class="height-100 mt-3">
		<v-card-title>
			<v-btn-toggle v-model="queryParam.state" @change="searchQuery" color="primary" mandatory dense group class="ml-n2">
				<v-btn :value="item.key" class="ml-2" v-for="(item, index) in btnGroup" :key="index">{{ item.val }}</v-btn>
			</v-btn-toggle>
			<v-spacer />
			<vtk-area-tabs v-model="queryParam.areaCode" @change="searchQuery" :minArea="6" :fixed="2" :styles="'max-width: 380px'" hide-details />
		</v-card-title>
		<v-card-text>
			<v-data-table :headers="headers" :items="desserts" :loading="loading" disable-pagination loading-text="数据加载中..." class="elevation-0 vtk-cursor-pointer" hide-default-footer>
				<template v-slot:[`item.first_col`]="{ item }">
					<span>{{ desserts.indexOf(item) + 1 }}</span>
				</template>
				<template v-slot:[`item.areaName`]="{ item }">
					<v-chip class="mr-2 areaChip px-2" :class="item.areaCode.length | dict('1:red--text bgRed/2:blue--text bgBlue/4:green--text bgGreen/6:orange--text bgOrange')" small label>
						{{ item.areaCode.length | dict("1:国家/2:省级/4:市级/6:区县") }}
					</v-chip>
					<span>{{ item.areaName }}</span>
				</template>
				<template v-slot:[`item.etime`]="{ item }">
					{{ item.btime | date("yyyy-MM-dd") }} ~ {{ item.etime | date("yyyy-MM-dd") }}
					<v-icon v-if="Math.floor((new Date() - new Date(item.etime)) / (1000 * 60 * 60 * 24)) > -30" color="red" size="8" class="mt-n1">mdi-brightness-1</v-icon>
				</template>
				<template v-slot:[`item.state`]="{ item }">
					<v-chip class="white--text" :class="item.state | dict('0:red/1:green')" small>{{ item.state | dict("0:无效/1:有效") }} </v-chip>
				</template>
				<template v-slot:[`item.projNote`]="{ item }">
					<span>{{ item.projNote | txt(20) }}</span>
				</template>
				<template v-slot:[`item.operateTime`]="{ item }">
					{{ item.operateTime | date("yyyy-MM-dd HH:mm:ss") }}
				</template>
				<template v-slot:[`item.actions`]="{ item }">
					<span @click="toView(item)" class="blue--text">详情</span>
					<span v-if="Math.floor((new Date() - new Date(item.etime)) / (1000 * 60 * 60 * 24)) > -30" @click="renewal(item)" class="orange--text ml-3">续签</span>
				</template>
				<template v-slot:no-data>
					<v-card class="px-6 pt-4 pb-4 mt-3" elevation="0" id="train">
						<p class="grey--text mt-4">暂无数据</p>
					</v-card>
				</template>
			</v-data-table>
			<v-divider />
			<pagination :page-sizes="[10, 20]" :page-data="pageData" @pageChange="getListPage" />
		</v-card-text>
		<!-- 续签 -->
		<dept-input ref="Madd" />
		<!-- 服务资质查看 -->
		<dept-ureg-view ref="mView" />
		<!--./服务资质查看 -->
	</v-card>
</template>

<script>
import DeptInput from "./dept-input";
// import Request from "@/commons/request";
import Storage from "@/commons/storage";
// import Message from "@/components/message";
import Mixins from "@/compositions/mixins/minxs";
import pagination from "@/components/pagination";
import DeptUregView from "./dept-ureg-view";
export default {
	name: "DashUrole",
	mixins: [Mixins],
	components: { pagination, DeptUregView, DeptInput },
	data() {
		return {
			// 地区资质列表
			url: { list: "/udsx/dept-roles/page" },
			btnGroup: [
				{ key: "A", val: "全部" },
				{ key: "1", val: "有效" },
				{ key: "0", val: "无效" },
			],
			queryParam: { state: "A" },
			headers: [
				{ text: "序号", value: "first_col", sortable: false, width: 60, align: "center" },
				{ text: "服务地区", value: "areaName", sortable: false },
				{ text: "服务时间", value: "etime", sortable: false },
				{ text: "联系人员", value: "linkName", sortable: false, width: 130 },
				{ text: "联系电话", value: "linkTele", sortable: false, width: 160 },
				{ text: "状态", value: "state", sortable: false, width: 130, align: "center" },
				// { text: "申请说明", value: "note", sortable: false },
				{ text: "操作时间", value: "operateTime", sortable: false, width: 200 },
				{ text: "操作", value: "actions", sortable: false, width: 110 },
			],
			desserts: [],
		};
	},
	activated() {
		this.queryParam.bid = this.$route.query.pid;
		this.queryParam.did = Storage.get("_wit_acis_users").did;
		this.loadPage();
	},
	methods: {
		//资质详情
		toView(item) {
			this.$refs.mView.view(item);
		},
		// 申请记录
		record() {
			this.$router.push({ path: "/dept-ureg", query: { pid: this.$route.query.pid } });
		},
		// 资质续签
		renewal(item) {
			this.$refs.Madd.edit(item, 1);
		},
	},
};
</script>

<style lang="scss" scoped>
.border-dashed {
	border: 1px #2196f3 dashed;
}
.border-solid {
	border: 1px rgba(182, 182, 182, 0.6) solid;
}
::v-deep .v-banner--single-line .v-banner__wrapper {
	padding: 0 !important;
}
.gray {
	filter: grayscale(100%);
}
.gray_75 {
	filter: hue-rotate(140deg);
}
.gray_50 {
	filter: hue-rotate(205deg);
}
.gray_0 {
	filter: grayscale(0%);
}
.serve_yhd {
	background: url(../../assets/img/yhd.png) no-repeat;
	background-size: contain;
	background-position: calc(100% + 12px) calc(100% + 18px);
}
.serve_sqz {
	background: url(../../assets/img/sqz.png) no-repeat;
	background-size: contain;
	background-position: calc(100% + 12px) calc(100% + 18px);
}
.serve_bjj {
	background: url(../../assets/img/bjj.png) no-repeat;
	background-size: contain;
	background-position: calc(100% + 12px) calc(100% + 18px);
}
::v-deep {
	> td.text-start:nth-child(2) {
		padding-left: 0;
		padding-right: 0;
	}
	// td.text-start:nth-child(3) {
	// 	padding-right: 0;
	// }
	.v-data-table__expanded__content {
		box-shadow: none !important;
		.v-data-table {
			background-color: #00000000;
		}
	}
	.v-input__prepend-outer {
		display: none;
	}
	// .v-data-table__expanded__content td:nth-child(1) {
	// 	padding-left: 0;
	// 	padding-right: 0;
	// 	// text-align: center;
	// }
}
.areaChip {
	height: auto;
}
.bgRed {
	background: #e91e6318 !important;
}
.bgGreen {
	background: #4caf5018 !important;
}
.bgBlue {
	background: #2196f318 !important ;
}
.bgOrange {
	background: #ff980018 !important;
}
</style>
